










































































import Vue from 'vue';
import Component from 'vue-class-component';
import authApi from '@/api/auth.api';
import * as types from '@/store/types';
import { mapGetters } from 'vuex';
import {Watch} from 'vue-property-decorator';

@Component({
    computed: mapGetters({
        companyPermissions: types.AUTH_HAS_COMPANY_PERMISSIONS,
        adminPermissions: types.AUTH_HAS_ADMIN_PERMISSIONS,
        superadminPermissions: types.AUTH_HAS_SUPERADMIN_PERMISSIONS,
        approveAgentsPermissions: types.AUTH_HAS_PERMISSION_APPROVE_AGENTS,
        unapprovedCount: types.APPROVE_UNAPPROVED_COUNT
    })
})
export default class AccountContainer extends Vue {
    // store
    public companyPermissions;
    public adminPermissions;
    public superadminPermissions;
    public approveAgentsPermissions;
    public unapprovedCount;

    public showMobileManuVal: boolean = false;

    public logout() {
        this.$store.dispatch(types.AUTH_LOGOUT);
        this.$router.push('/login');
        authApi.logout(); // need for set time on Online_Logs table
    }

    @Watch('$route') private onRouteChanged(val: string, oldVal: string) {
        this.showMobileManuVal = false;
    }
}
